import { render, staticRenderFns } from "./OtManagementTemplate.vue?vue&type=template&id=4d4f41e0&scoped=true"
import script from "./OtManagementTemplate.vue?vue&type=script&lang=js"
export * from "./OtManagementTemplate.vue?vue&type=script&lang=js"
import style0 from "./OtManagementTemplate.vue?vue&type=style&index=0&id=4d4f41e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4f41e0",
  null
  
)

export default component.exports